var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTestImg1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "icon_x5F_layer"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#72CBCC"
    },
    points: "151.448,231.791 140.389,213.652 129.031,203.472  115.187,222.405 97.86,253.999 128.972,246.823  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#3AA0BA"
    },
    points: "177.878,162.389 190.555,199.925 149.69,237.423  163.412,173.331  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#5EC0D9"
    },
    points: "97.617,66.915 168.587,53.397 151.83,156.069  76.855,155.269  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#165E60"
    },
    points: "96.527,91.929 147.103,84.537 120.067,98.539  114.39,123.605 103.512,124.344 109.257,98.942  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#318FA6"
    },
    points: "168.587,53.397 216.146,98.056 172.209,171.926  154.113,162.654 148.309,150.441  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#165E60"
    },
    points: "76.855,155.269 148.309,150.441 172.209,171.926  149.921,186.344 123.93,197.029  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#1C7678"
    },
    points: "123.93,197.029 151.448,231.791 172.209,171.926  154.513,181.126  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#72CBCC"
    },
    points: "190.555,199.925 222.902,205.236 214.094,225.019  196.353,248.207 174.332,243.522 151.448,231.791  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#51A9AB"
    },
    points: "129.031,203.472 87.72,218.274 97.86,253.999  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#51A9AB"
    },
    points: "222.902,205.236 235.937,260.276 211.813,256.303  196.353,248.207  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#27788C"
    },
    points: "235.937,260.276 220.49,291.174 188.623,299.383  190.173,263.974 196.353,248.207  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#318FA6"
    },
    points: "188.623,299.383 105.583,284.899 97.86,253.999  151.448,231.791 196.353,248.207  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#27788C"
    },
    d: "M144.207,40.119c-44.264,0-80.144-8.969-80.144-20.035 l9.1-3.167l8.281,3.167c0,5.732,28.1,10.382,62.764,10.382l3.52,4.148L144.207,40.119z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#51A9AB"
    },
    d: "M224.355,20.084c0,11.066-35.886,20.035-80.148,20.035v-9.653 c34.66,0,62.762-4.65,62.762-10.382l7.656-1.76L224.355,20.084z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#318FA6"
    },
    d: "M144.207,0.049c44.261,0,80.148,8.969,80.148,20.035h-17.386 c0-5.732-28.102-10.379-62.762-10.379l-3.17-3.948L144.207,0.049z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#72CBCC"
    },
    d: "M64.063,20.084c0-11.065,35.88-20.035,80.144-20.035v5.357 v4.299c-34.664,0-62.764,4.647-62.764,10.379H64.063z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "guidelines"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestImg1);
export default __webpack_public_path__ + "static/media/testImg1.05020c6ea7954bee88f00fe4a6db0bb1.svg";
export { ForwardRef as ReactComponent };